import { RECEIVE_THEMES } from '../actions';
import { shuffle } from '../utils/array';

export const themes = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_THEMES:
      const themes = action.shuffle === false ? action.themes : shuffle(action.themes);
      return themes;
    default:
      return state;
  }
}
